import React from 'react';

import { useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { JiraAppSelectorIcon } from './jira-app-selector';
import { messages } from './messages';

const styles = cssMap({
	moreButtonStyles: {
		alignItems: 'center',
		backgroundColor: token('elevation.surface.sunken'),
		border: `${token('border.width')} solid ${token('color.border.inverse')}`,
		borderRadius: token('radius.small'),
		display: 'flex',
		paddingLeft: token('space.100'),
		paddingRight: token('space.075'),
	},
	iconsStyles: {
		display: 'flex',
		translate: token('space.025'),
	},
});

export const AllAppsIcon: () => React.JSX.Element = () => {
	const { formatMessage } = useIntl();

	return (
		<Flex role="presentation" alignItems="center">
			<Box xcss={styles.iconsStyles}>
				<JiraAppSelectorIcon />
			</Box>

			<Box xcss={styles.moreButtonStyles}>
				<Text size="small" align="center" color="color.text.subtle">
					{formatMessage(messages.more)}
				</Text>
			</Box>
		</Flex>
	);
};
